import getBposShellInfoNavBarDataOperation from 'owa-service/lib/operation/getBposShellInfoNavBarDataOperation';
import getBposShellInfoNavBarDataForBookingsOperation from 'owa-service/lib/operation/getBposShellInfoNavBarDataForBookingsOperation';
import NavBarData from 'owa-service/lib/contract/NavBarData';

let navBarDataPromise: Promise<NavBarData | null>;
let navBarData: NavBarData | null;

export function getBposNavBarDataAsync(
    appName?: string,
    ignoreAuthError?: boolean
): Promise<NavBarData | null> {
    if (!navBarDataPromise) {
        const operation =
            appName === 'Bookings'
                ? getBposShellInfoNavBarDataForBookingsOperation
                : getBposShellInfoNavBarDataOperation;
        navBarDataPromise = operation({ authNeededOnUnAuthorized: !ignoreAuthError })
            .then(data => {
                return (navBarData = data);
            })
            .catch(() => {
                return (navBarData = null);
            });
    }
    return navBarDataPromise;
}

export function getBposPromise(): Promise<NavBarData | null> | undefined {
    return navBarDataPromise;
}

export function getBposNavBarData(): NavBarData | null {
    return navBarData;
}
